import { Image, Link, Text, View } from "@react-pdf/renderer";

import { styles } from "../../Tables";

export const TableRowDostavaEvdListaDefinisanihTacakaHeader: React.FC<{
  datum: string;
  posiljalac: string;
  primalac: string;
  potpisPrimalac: string;
  dokument: string;
  primjedba: string;
  korektivnaMjera: string;
  ispravnaPosiljka: string;
  brojRacuna: string;
}> = ({
  datum,
  posiljalac,
  primalac,
  potpisPrimalac,
  dokument,
  primjedba,
  korektivnaMjera,
  ispravnaPosiljka,
  brojRacuna,
}) => (
  <View style={styles.tableRow}>
    <View style={styles.tableCol}>
      <Text>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{posiljalac}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{primalac}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{potpisPrimalac}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{brojRacuna}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{dokument}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{ispravnaPosiljka}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{primjedba}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text>{korektivnaMjera}</Text>
    </View>
  </View>
);

export const TableRowDostavaEvdListaDefinisanihTacaka: React.FC<{
  datum: string;
  posiljalac: string;
  primalac: string;
  potpisPrimalac: string;
  dokument?: string;
  primjedba: string;
  korektivnaMjera: string;
  slikaRes: string;
  ispravnaPosiljka: string;
  brojRacuna: string;
}> = ({
  datum,
  posiljalac,
  primalac,
  potpisPrimalac,
  dokument,
  primjedba,
  korektivnaMjera,
  slikaRes,
  ispravnaPosiljka,
  brojRacuna,
}) => (
  <View style={styles.tableRow} wrap={false}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{datum}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{posiljalac}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{primalac}</Text>
    </View>
    <View style={styles.tableCol}>
      {potpisPrimalac && (
        <Image
          style={[styles.tableCell, styles.signatureImage]}
          src={potpisPrimalac}
        />
      )}
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{brojRacuna}</Text>
    </View>
    <View style={styles.tableCol}>
      {dokument && (
        <Link src={dokument} style={{ ...styles.tableCell, ...styles.link }}>
          {slikaRes}
        </Link>
      )}
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{ispravnaPosiljka}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{primjedba}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{korektivnaMjera}</Text>
    </View>
  </View>
);
